import { useForm, UseFormProps } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { CommunityProfileOnboardingDto, UpdateUserAddressDto } from '@sweatpals/shared';
import { CreateCommunityFormData } from '../create-community';
import { defaultCommunityColor } from '../../../constants';
import { CreateCommunityFormValidator } from '../../../models/dto/user.dto';
import { AddressInfoDto } from '../../../interfaces';

export type GetAddressInfoFromAddressCallback = (address: string) => Promise<AddressInfoDto>;

const resolver = classValidatorResolver(CreateCommunityFormValidator);

export const useCreateCommunityFlowForm = <Context = any>(props?: UseFormProps<CreateCommunityFormValidator, Context>) => {
	const form = useForm<CreateCommunityFormData>({
		...props,
		defaultValues: {
			...props?.defaultValues,
			primaryColor: defaultCommunityColor,
		},
		mode: 'onChange',
		resolver,
	});

	const formData = form.watch();

	return {
		form,
		formData,
		errors: form.formState.errors,
	};
};

export const prepareCreateCommunityDataBeforeSubmit = async (
	data: CreateCommunityFormData,
	getAddressInfoFromAddress: GetAddressInfoFromAddressCallback
): Promise<CommunityProfileOnboardingDto> => {
	const { ...rest } = data;

	if (rest.addresses?.length) {
		const placeOptions = rest.addresses;

		if (!getAddressInfoFromAddress) {
			throw new Error('Google Maps API method is required to get the location details');
		}

		const updatedAddresses = await Promise.all(
			placeOptions.map(async (place) => {
				const addressInfo = await getAddressInfoFromAddress(place.description);

				return {
					addressName: place.description,
					addressLat: addressInfo.lat.toString(),
					addressLng: addressInfo.lng.toString(),
				} as UpdateUserAddressDto;
			})
		);

		rest.updatedAddresses = updatedAddresses;
	}

	return { ...rest };
};
